module.exports = __webpack_public_path__ + "img/order-now.a2e3fd27.png";